module.exports = __webpack_public_path__ + "static/media/social_climbing.f5665f6c.jpg";